<template>
    <div>
        <Navbar :forceBg="true" />
        <section id="contrate" class="conteudo">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>Contrate ou Renove a sua Assinatura</h1>
                        <h4>Escolha abaixo qual opção de pagamento é mais interessante pra você:</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <h4>Planos com 1 Acesso Simultâneo</h4>
                    </div>
                    <div class="col-md-3">
                        <table class="table  table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">PIX<br><small>1 Acesso Simultâneo.</small></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td> 30 dias </td>
                                    <td> 90 dias </td>
                                </tr>
                                <tr class="valores">
                                    <td> R$ 30,00 </td>
                                    <td> R$ 83,00 </td>
                                </tr>
                                <tr>
                                    <td><button class="btn btn-success" @click="popup('Assinatura de 30 dias com PIX', 'Para pagar com o PIX é muito simples, basta você fazer do seu banco um PIX pra agente:<br><br> PIX: <strong>pix@ilimitadatv.com</strong><br>Valor: <strong>R$30,00.</strong><br><br><br>Após concluir, informe o nosso time sobre o seu pagamento que liberaremos sua conta na mesma hora.')">Pagar</button></td>
                                    <td><button class="btn btn-success" @click="popup('Assinatura de 90 dias com PIX', 'Para pagar com o PIX é muito simples, basta você fazer do seu banco um PIX pra agente:<br><br> PIX: <strong>pix@ilimitadatv.com</strong><br>Valor: <strong>R$83,00.</strong><br><br><br>Após concluir, informe o nosso time sobre o seu pagamento que liberaremos sua conta na mesma hora.')">Pagar</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-3">
                        <table class="table  table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">PICPAY<br><small>1 Acesso Simultâneo.</small></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td> 30 dias </td>
                                    <td> 90 dias </td>
                                </tr>
                                <tr class="valores">
                                    <td> R$ 30,00 </td>
                                    <td> R$ 83,00 </td>
                                </tr>
                                <tr>
                                    <td><button class="btn btn-success" @click="link('https://app.picpay.com/user/tihhgoncalves/30.00');">Pagar</button></td>
                                    <td><button class="btn btn-success" @click="link('https://app.picpay.com/user/tihhgoncalves/83.00');">Pagar</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <table class="table  table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">MERCADO PAGO<br><small>Cartão de Crédito, Boleto ou Débito da Caixa. 1 Acesso Simultâneo. </small>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td> 30 dias </td>
                                    <td> 90 dias </td>
                                </tr>
                                <tr class="valores">
                                    <td> R$ 33,00 </td>
                                    <td> R$ 86,00 </td>
                                </tr>
                                <tr>
                                    <td><button class="btn btn-success" @click="link('https://mpago.la/2czB5Q6');">Pagar</button></td>
                                    <td><button class="btn btn-success" @click="link('https://mpago.la/31vBkpj');">Pagar</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>


                <div class="row">
                    <div class="col-md-12">
                        <h4>Planos com 2 Acessos Simultâneos</h4>
                    </div>
                    <div class="col-md-3">
                        <table class="table  table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">PIX<br><small>2 Acessos Simultâneos.</small></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td> 30 dias </td>
                                    <td> 90 dias </td>
                                </tr>
                                <tr class="valores">
                                    <td> R$ 57,00 </td>
                                    <td> R$ 163,00 </td>
                                </tr>
                                <tr>
                                    <td><button class="btn btn-success" @click="popup('Assinatura de 30 dias com PIX', 'Para pagar com o PIX é muito simples, basta você fazer do seu banco um PIX pra agente:<br><br> PIX: <strong>pix@ilimitadatv.com</strong><br>Valor: <strong>R$57,00.</strong><br><br><br>Após concluir, informe o nosso time sobre o seu pagamento que liberaremos sua conta na mesma hora.')">Pagar</button></td>
                                    <td><button class="btn btn-success" @click="popup('Assinatura de 90 dias com PIX', 'Para pagar com o PIX é muito simples, basta você fazer do seu banco um PIX pra agente:<br><br> PIX: <strong>pix@ilimitadatv.com</strong><br>Valor: <strong>R$163,00.</strong><br><br><br>Após concluir, informe o nosso time sobre o seu pagamento que liberaremos sua conta na mesma hora.')">Pagar</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-3">
                        <table class="table  table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">PICPAY<br><small>2 Acessos Simultâneos.</small></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td> 30 dias </td>
                                    <td> 90 dias </td>
                                </tr>
                                <tr class="valores">
                                    <td> R$ 57,00 </td>
                                    <td> R$ 163,00 </td>
                                </tr>
                                <tr>
                                    <td><button class="btn btn-success" @click="link('https://app.picpay.com/user/tihhgoncalves/57.00');">Pagar</button></td>
                                    <td><button class="btn btn-success" @click="link('https://app.picpay.com/user/tihhgoncalves/163.00');">Pagar</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <table class="table  table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">MERCADO PAGO<br><small>Cartão de Crédito, Boleto ou Débito da Caixa. 2 Acessos Simultâneos. </small>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td> 30 dias </td>
                                    <td> 90 dias </td>
                                </tr>
                                <tr class="valores">
                                    <td> R$ 60,00 </td>
                                    <td> R$ 166,00 </td>
                                </tr>
                                <tr>
                                    <td><button class="btn btn-success" @click="link('https://mpago.la/1D5b8xX');">Pagar</button></td>
                                    <td><button class="btn btn-success" @click="link('https://mpago.la/194c8xC');">Pagar</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>


                <div class="row">
                    <div class="col-md-12"> Após evetuar o seu pagamento, informe a nossa equipe no WhatsApp: (47)9
                        9778-2969 (ou <a
                            href="http://wa.me/5511967359764?text=Gostaria de confirmar um pagamento.">clique aqui</a>)
                            <br>
                            <small>
                                Pagamentos parciais (com valores menores do que está descrito nessa página) pemanecerão pendentes até que seja feito o pagamento do saldo restante.
                                <br>
                                O prazo de compensação (e consequentemente liberação da sua conta) é de minutos, exceto para pagamentos no Boleto bancário que pode demorar de 1 a 2 dias úteis para a compensação e confirmação do pagamento.
                            </small>
                    </div>
                </div>
            </div>
        </section>]
        <Footer />
    </div>
</template>

<style scoped>
    table tr.valores{
        font-weight: 500;
        font-size: 1.13rem;
    }
</style>

<script>

import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";



export default {
    components: {
        Navbar,
        Footer,
    },

    methods: {

        popup: function(titulo, texto){
            Swal.fire(titulo, texto);
        },

        link: function(url){
            window.open(url, '_blank');
        }

    }
}
</script>
